import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../../../api'

const baseURL = `${baseAPI}/configuration`

export const getPaymentTypesKey = 'getPaymentTypes'

export const getPaymentTypes = (params?: GetPaymentTypesRequest) =>
  axios.get<GetPaymentTypesResponse>(`${baseURL}/payment-types`, {
    params
  })
